export const SET_CLIENT_ROOM = 'setClientRoom';
export const SET_EMPLOYEE_ROOM = 'setEmployeeRoom';
export const FETCH_UNITS = 'fetchUnits';
